module.exports = {"svg":{"$":{"t":"1536028568145","class":"icon","style":"","viewBox":"0 0 1024 1024","version":"1.1","xmlns":"http://www.w3.org/2000/svg","p-id":"3629","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"200","height":"200"},"defs":[{"style":[{"$":{"type":"text/css"}}]}],"path":[{"$":{"d":"M866.1 875h-662V160.7H866V875z m-612-50H816V210.7H254.1V825z","fill":"#040000","p-id":"3630"}},{"$":{"d":"M364.6 654.5H589v50H364.6zM364.6 492h340.9v50H364.6zM364.6 329.5h340.9v50H364.6z","fill":"#040000","p-id":"3631"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/assets/svg/order.svg
// module id = bW7X
// module chunks = 1